// extracted by mini-css-extract-plugin
export default {"value-box":"value-box_value-box__oCgjB","web":"value-box_web__yPhXD","value":"value-box_value__hlk2u","mobile":"value-box_mobile__nuZC8"};